export default "__VITE_ASSET__Ck5FWV4T__"